import {useRouter} from 'next/router';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import useFilterPositions from '@/src/jobPortal/common/hooks/useFilterPositions';
import FilterRow from '@/src/Search/components/FilterRow';
import {useSearchFilters} from '@/src/Search/utils/useSearchFilters';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {CheckboxCommon, SimpleCollapse, Text} from '@/src/ui';

import css from '../styles/FilterRow.module.css';

const PositionsTypeFilter = () => {
  const {positions} = useFilterPositions();
  // @ts-ignore
  const {onMultipleFilterClickHandle} = useSearchFilters();
  const {query, locale} = useRouter();

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.positionFilterTitle'} />
        </Text>
      }
    >
      <FilterRow>
        <div className={css.checkboxesMaxHeight}>
          {positions?.map((position) => (
            <div key={position.id} className={css.checkboxes}>
              <CheckboxCommon
                id={`specialties${position.id}`}
                name={position[`name_${locale}`]}
                label={position[`name_${locale}`]}
                data-filter-name={SEARCH_FILTERS.POSITIONS}
                data-value={position.id.toString()}
                checked={
                  !!query[SEARCH_FILTERS.POSITIONS] &&
                  // @ts-ignore
                  JSON.parse([query[SEARCH_FILTERS.POSITIONS]]).includes(
                    String(position.id)
                  )
                }
                onChange={onMultipleFilterClickHandle}
                isSemibold
                error={undefined}
              />
            </div>
          ))}
        </div>
      </FilterRow>
    </SimpleCollapse>
  );
};

export default PositionsTypeFilter;
